module.exports = __webpack_public_path__ + "img/zadania.e0610f32.svg";